import BlogList from './blogList.container'

export default BlogList